module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form-capsule', {
    attrs: {
      "formTitle": _vm.$t('businessDocuments.business_doc_negotiation')
    }
  }, [_c('template', {
    slot: "formcontent"
  }, [_vm._v("\n    " + _vm._s(_vm.document.id) + "\n  ")]), _vm._v(" "), _c('template', {
    slot: "footerbuttons"
  })], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5a8addd8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a8addd8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/requests/negotiationPages/BusinessDocumentNegotiation.vue
// module id = 2424
// module chunks = 2